import { render, staticRenderFns } from "./InternalCommentsDialog.vue?vue&type=template&id=538cdaa2&scoped=true"
import script from "./InternalCommentsDialog.vue?vue&type=script&lang=js"
export * from "./InternalCommentsDialog.vue?vue&type=script&lang=js"
import style0 from "./InternalCommentsDialog.vue?vue&type=style&index=0&id=538cdaa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538cdaa2",
  null
  
)

export default component.exports